import {
  Map,
  MapControl,
  MapControls,
  MapGeolocationCustomControl,
  MapZoomCustomControl,
  Route,
} from '@logistics-frontend/blocks'
import React, {memo} from 'react'

import {i18n} from 'src/shared/config'

import {MapPlacemarks} from '../MapPlacemarks/MapPlacemarks'
import {useFormMap} from './hooks'
import {type Props} from './types'

export const FormMapUI = memo<Props>(function FormMapUI(props) {
  const {
    mapLocation,
    mapMargin,
    controlsPosition,
    lang,
    routePointCoordinates,
    geolocationClickHandler,
    isRouteVisible,
    location,
    orderPointsCoordinates,
    isDragPointAllowed,
    updateMapLocation,
    onPlacemarkChange,
  } = useFormMap(props)

  return (
    <Map errorMessage={i18n('map_load_error')} lang={lang} location={mapLocation} margin={mapMargin}>
      {isRouteVisible && <Route onBoundsChange={updateMapLocation} points={routePointCoordinates} />}
      <MapControls position={controlsPosition}>
        <MapControl>
          <MapZoomCustomControl setLocation={updateMapLocation} />
        </MapControl>
        <MapControl>
          <MapGeolocationCustomControl initialLocation={location} onGeolocatePosition={geolocationClickHandler} />
        </MapControl>
      </MapControls>
      <MapPlacemarks
        allPoints={orderPointsCoordinates}
        isDragPointAllowed={isDragPointAllowed}
        onChange={onPlacemarkChange}
        onLocationRequest={updateMapLocation}
        route={routePointCoordinates}
      />
    </Map>
  )
})
